import React from 'react';

const NotFound = () => {
  return (
    <h1 style={{textAlign: 'center', color: '#fff', marginTop: '20px'}}>Página não encontrada</h1>
  )
}

export default NotFound;